import { useMemo } from "react";
import { HgsLocation, HgsVendorInfo, HgsSettings } from "./types";

function readFromWindow(): HgsSettings {
  if (typeof window === "undefined") {
    return { location: null, vendorInfo: null };
  }

  const w = window as any;

  return {
    location: (w.Hgs?.Location as HgsLocation) ?? null,
    vendorInfo: (w.Hgs?.VendorInfo as HgsVendorInfo) ?? null,
  };
}

export function useHgsSettings(): HgsSettings {
  return useMemo(() => readFromWindow(), []);
}
